enum AuthActions {
  SET_AUTH = "SET_AUTH",
  DONE_AUTHEN_ACTION = "DONE_AUTHEN_ACTION"
}

export default AuthActions;
